import { NpcSeriesPage } from '@/components/admin/npc/series/series-page';
import { createFileRoute } from '@tanstack/react-router';

/**
 * La page d'une série (npc.md §9, issue #210) : `/admin/npc/series/<id>`.
 *
 * Un montage et rien d'autre : la page est `NpcSeriesPage`, un composant, pour que ce qu'elle fait -
 * le sondage tant que la série tourne, « Arrêter », « Relancer » - soit couvert par des tests
 * (`vitest.config.ts` laisse `src/routes/**` hors du rapport). Le fichier est un FRÈRE de
 * `npc.$npcId.tsx` et pas son enfant : `series` a deux segments de plus que `$npcId`, et
 * `/admin/npc/series` seul n'est pas une adresse.
 */

export const Route = createFileRoute('/admin/npc/series/$id')({
  component: NpcSeriesRoute,
});

function NpcSeriesRoute() {
  const { id } = Route.useParams();
  return <NpcSeriesPage seriesId={id} />;
}
